import React from 'react';
import { AlertCircle, Globe, Search, MessageSquareX, TrendingDown } from 'lucide-react';

const ProblemSection = () => {
  const problems = [
    {
      icon: Globe,
      title: 'Outdated Websites',
      description: 'Old, slow websites that don\'t work on mobile and fail to convert visitors into customers.',
    },
    {
      icon: Search,
      title: 'Poor Google Visibility',
      description: 'Invisible on Google search, losing potential customers to competitors with better SEO.',
    },
    {
      icon: MessageSquareX,
      title: 'Missed Inquiries',
      description: 'Customer questions go unanswered after hours, resulting in lost sales opportunities.',
    },
    {
      icon: TrendingDown,
      title: 'No Digital Strategy',
      description: 'Lack of expertise in digital marketing, automation, and modern online presence.',
    },
  ];

  return (
    <section 
      className="py-24 lg:py-32 bg-slate-50"
      data-testid="problem-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-50 border border-red-100 mb-6">
            <AlertCircle className="w-4 h-4 text-red-500" />
            <span className="text-sm font-medium text-red-600">The Problem</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Local Businesses Are{' '}
            <span className="text-red-500">Falling Behind</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Many local businesses struggle with outdated websites, poor Google visibility, missed customer inquiries, and lack of digital marketing expertise. As a result, they lose potential customers to competitors with better online presence.
          </p>
        </div>

        {/* Problem Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-lg hover:border-red-100 transition-all duration-300"
              data-testid={`problem-card-${index}`}
            >
              <div className="w-14 h-14 rounded-xl bg-red-50 flex items-center justify-center mb-5 group-hover:bg-red-100 transition-colors">
                <problem.icon className="w-7 h-7 text-red-500" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {problem.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Message */}
        <div className="mt-16 text-center">
          <p className="text-lg text-slate-700 font-medium">
            Don't let your competitors get ahead.{' '}
            <span className="text-blue-600">AI-powered solutions can change everything.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
